export default "__VITE_ASSET__CgDBg52y__"